import { FC } from 'react'

import './style.scss'
import { Icon } from '..'

interface TooltipProps {
  className?: string,
  icon?: string,
  color?: string,
  width?: string,
  align?: 'LEFT' | 'CENTER' | 'RIGHT' | ''
}

const Tooltip:FC<TooltipProps> = ({ className = '', children, icon = 'tooltip', color, width, align = '' }) => {
  return (
    <div className={`tooltip ${className}`}>
      <Icon
        name={icon}
        color={color}
      />
      <div className={`tooltip_content ${align ? 'tooltip_content--' + align?.toLowerCase() : ''}`} style={{ width }}>
        {children}
      </div>
    </div>
  )
}

export { Tooltip }